import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import ContentWell from '@components/libraryV2/ContentWell';
import Text from '@components/libraryV2/Text';
import TextBubble from '@components/libraryV2/TextBubble';
import ThemeText from '@components/libraryV2/ThemeText';

import * as styles from './styles.module.scss';

const Detail = (props) => {
  const { children, Image, position, title } = props;

  return (
    <div className={styles.detail}>
      <div className={styles.detailImage}>{Image}</div>
      <TextBubble className={styles.bubble} size="mouse">
        {position}
      </TextBubble>
      <div className={styles.detailContent}>
        <div className={styles.detailTitle}>{title}</div>
        <div className={styles.detailChildren}>{children}</div>
      </div>
    </div>
  );
};

const Introduction = () => (
  <ContentWell size="dog" secondary tighten>
    <div className={styles.banner}>
      <Text size="wolf" theme="secondary" weight="medium" uppercase>
        Introducing
      </Text>
      <StaticImage
        alt="Achievable logo"
        className={styles.logo}
        src="../../../images/shared/logo-text-horizontal theme=transparent-300h.svg"
        width={320}
      />
      <Text size="wolf" theme="secondary" weight="bold">
        Study and pass. <ThemeText>Period</ThemeText>.
      </Text>
    </div>

    <div className={styles.content}>
      <div className={styles.dashboardContainer}>
        <StaticImage
          className={styles.dashboard}
          alt="Achievable dashboard shown on desktop and mobile"
          src="../../../images/home/labeled-dashboard.webp"
        />
      </div>

      <div className={styles.details}>
        <Detail
          Image={
            <StaticImage
              alt="Achievable content progress"
              src="../../../images/home/labeled-content-progress.webp"
            />
          }
          position={1}
          title="A guided path to success"
        >
          Know where you are, and what's next, at a glance. Visualize your progress as you read
          through our complete online material. No need to carry around bulky textbooks.
        </Detail>
        <Detail
          Image={
            <StaticImage
              alt="Achievable memory progress"
              src="../../../images/home/labeled-memory-progress.webp"
            />
          }
          position={2}
          title="Optimize memory retention"
        >
          Let our adaptive learning engine do the work for you. Our algorithms create and continually update a personalized map of your memory, giving you refresher quizzes at the perfect moment.
        </Detail>
        <Detail
          Image={
            <StaticImage
              alt="Achievable quizzes shown on mobile"
              src="../../../images/home/labeled-mobile-view.webp"
            />
          }
          position={3}
          title="Study anytime, anywhere"
        >
          Made for busy people with busy schedules. With our best-in-class mobile experience, you can
          access course materials anywhere and anytime.
        </Detail>
      </div>
    </div>
  </ContentWell>
);

export default Introduction;
